import React from 'react';
import './index.css'
const Pagination = ({ currentPage, totalRecords, itemsPerRow = 10, handlePageChange }) => {
    // Generate an array of page numbers
    const totalPages = Math.ceil(totalRecords / itemsPerRow)
    const getPageNumbers = () => {
        const pageNumbers = [];
        for (let i = 1; i <= totalPages; i++) {
            pageNumbers.push(i);
        }
        return pageNumbers;
    };

    // Get the page numbers to display in the pagination controls
    const getPageNumbersToDisplay = () => {
        const pageNumbers = getPageNumbers();
        const displayedPageNumbers = [];

        if (totalPages <= 7) {
            return pageNumbers;
        }

        const firstPage = 1;
        const lastPage = totalPages;

        const currentPageIndex = currentPage - 1;

        if (currentPageIndex < 4) {
            displayedPageNumbers.push(...pageNumbers.slice(0, 5));
            displayedPageNumbers.push('...');
            displayedPageNumbers.push(lastPage);
        } else if (currentPageIndex >= 4 && currentPageIndex <= totalPages - 5) {
            displayedPageNumbers.push(firstPage);
            displayedPageNumbers.push('...');
            displayedPageNumbers.push(...pageNumbers.slice(currentPageIndex - 1, currentPageIndex + 2));
            displayedPageNumbers.push('...');
            displayedPageNumbers.push(lastPage);
        } else {
            displayedPageNumbers.push(firstPage);
            displayedPageNumbers.push('...');
            displayedPageNumbers.push(...pageNumbers.slice(totalPages - 5));
        }

        return displayedPageNumbers;
    };

    return (

        <div className='pagination-component'>
            {
                totalRecords ?
                    <>

                        <div className='pagination-component__record'>
                            Showing {currentPage}-{totalPages} of {totalRecords}
                        </div>
                        <div>
                            {currentPage > 1 && (
                                <button onClick={() => handlePageChange(currentPage - 1)} className='pagination-component__button'> <i className="bi bi-chevron-left"></i></button>
                            )}

                            {getPageNumbersToDisplay().map((pageNumber, index) => (
                                <React.Fragment key={index}>
                                    {pageNumber === '...' ? (
                                        <span>{pageNumber}</span>
                                    ) : (
                                        <button
                                            onClick={() => handlePageChange(pageNumber)}
                                            className={currentPage == pageNumber ? 'pagination-component__button pagination-component__button--active' : 'pagination-component__button'}
                                        >
                                            {pageNumber}
                                        </button>
                                    )}
                                </React.Fragment>
                            ))}

                            {currentPage < totalPages && (
                                <button onClick={() => handlePageChange(currentPage + 1)} className='pagination-component__button'><i className="bi bi-chevron-right"></i></button>
                            )}
                        </div>
                        <div>

                        </div>
                    </>
                    :
                    <div className='pagination-component__record text-center w-100'>
                        No Records Found
                    </div>
            }
        </div>
    );
};

export default Pagination;